<template>
  <div></div>
</template>

<script>
export default {
  props: {
    sitekey: {
      type: String,
      required: true
    }
  },

  methods: {
    loadReCaptchaScript() {
      const scriptId = '__RECAPTCHA_SCRIPT';
      if (document.getElementById(scriptId)) return;

      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    },

    tryRenderCaptcha() {
      // The re-Captcha API supports a global onload callback function;
      // use polling instead to avoid polluting the global object.
      if (!window.grecaptcha?.render) {
        setTimeout(this.tryRenderCaptcha, 1000);
        return;
      }

      window.grecaptcha.render(this.$el, {
        sitekey: this.sitekey,
        callback: token => this.$emit('verified', token),
        'expired-callback': () => this.$emit('expired'),
        'error-callback': () => this.$emit('error'),
      });
    }
  },

  created() {
    this.loadReCaptchaScript();
  },

  mounted() {
    this.tryRenderCaptcha();
  }
};
</script>
